import type { IAnyType } from 'mobx-state-tree';
import { types } from 'mobx-state-tree';

export const edges = <T extends IAnyType>(nodeModel: T) => {
  return types.model({
    edges: types.array(
      types.model({
        node: nodeModel,
      }),
    ),
  });
};

export const nullOrUndefined = <T extends IAnyType>(type: T) => {
  return types.maybe(types.maybeNull(type));
};
